import { RootState } from "../../store.types";
import { State } from "./social.types";

export const getCurrentState = (state: RootState): State => state.social;

export const isPostLoading = (state: RootState) =>
  getCurrentState(state).post.isPostLoading;

export const getPostList = (state: RootState) =>
  getCurrentState(state).post.postList;

export const getPostError = (state: RootState) =>
  getCurrentState(state).post.error;

export const isPricingLoading = (state: RootState) =>
  getCurrentState(state).pricing.isPricingLoading;

export const getPricingObject = (state: RootState) =>
  getCurrentState(state).pricing.pricingObject;

export const getReportSuccess = (state: RootState) =>
  getCurrentState(state).report.success;

export const getReportError = (state: RootState) =>
  getCurrentState(state).report.error;

export const getReportDetail = (state: RootState) =>
  getCurrentState(state).report.detail;

export const isSocialReportLoading = (state: RootState) =>
  getCurrentState(state).report.isSocialReportLoading;

export const getProfileList = (state: RootState) =>
  getCurrentState(state).profiles.profileList;

export const isProfilesLoading = (state: RootState) =>
  getCurrentState(state).profiles.isProfilesLoading;

export const isReportReady = (state: RootState) =>
  getCurrentState(state).report.isReportReady;
